import { connect, ConnectedProps } from 'react-redux';
import { Row, Col } from 'antd';
import { useLocation } from 'react-router';
import { hasCurrentUser, hasCurrentUserLoaded } from '@store/selectors';
import { StoreState } from '@root/types';
import routes from '@root/routes';
import actions from '@store/actions/navigation';
import useEnv from '@shared/useEnv';
import { getSessionStorageValues } from '@shared/sessionStorageForSiteVisitors';
import StandardNavigation from './StandardNavigation';
import MobileNavigation from './MobileNavigation';

const { root: homepagePath } = routes;

const mapState = (state: StoreState) => ({
  currentUser: state.currentUser,
  someoneIsLoggedIn: hasCurrentUser(state),
  isCurrentUserLoaded: hasCurrentUserLoaded(state),
});

const mapDispatch = dispatch => ({
  searchClicked: () => dispatch(actions.searchClicked()),
  savedItemsClicked: (savedItemsType: string) =>
    dispatch(actions.savedItemsClicked(savedItemsType)),
  tourbooksClicked: () => dispatch(actions.tourbooksClicked),
  accountClicked: () => dispatch(actions.accountClicked),
  nameClicked: () => dispatch(actions.nameClicked),
});

const connector = connect(mapState, mapDispatch);
type ReduxProps = ConnectedProps<typeof connector>;

export type TrackerProps = {
  searchClicked: () => void;
  savedItemsClicked: (savedItemsType: string) => void;
  nameClicked: () => void;
  tourbooksClicked: () => void;
  accountClicked: () => void;
};

const Navigation = ({
  currentUser,
  someoneIsLoggedIn,
  isCurrentUserLoaded,
  savedItemsClicked,
  searchClicked,
  tourbooksClicked,
  accountClicked,
  nameClicked,
}: ReduxProps) => {
  const { pathname } = useLocation();
  const { locale } = useEnv();
  const { arrivedOnMarketLink, arrivedOnShareLink } = getSessionStorageValues();

  const hideLogInAndSignUp = locale === 'en-gb' && (arrivedOnMarketLink || arrivedOnShareLink);
  const showUniversalSearch = pathname !== homepagePath && someoneIsLoggedIn;
  const trackers = {
    searchClicked,
    savedItemsClicked,
    tourbooksClicked,
    accountClicked,
    nameClicked,
  };

  return (
    <Row id="site-navigation">
      <Col sm={0} md={24} lg={24} data-testid="standard-navigation">
        <StandardNavigation
          showUniversalSearch={showUniversalSearch}
          currentUser={currentUser}
          isCurrentUserLoaded={isCurrentUserLoaded}
          trackers={trackers}
          hideLogInAndSignUp={hideLogInAndSignUp}
        />
      </Col>
      <Col sm={24} md={0} lg={0} data-testid="mobile-navigation">
        <MobileNavigation
          showUniversalSearch={showUniversalSearch}
          currentUser={currentUser}
          trackers={trackers}
          hideLogInAndSignUp={hideLogInAndSignUp}
        />
      </Col>
    </Row>
  );
};

export default connector(Navigation);
